import axios from "axios";
import {User} from "../ebelediye/entities/User";
import {encodeBase64} from "../utils";
import {
  YONETICI_BANKA_BAKIYE_DURUMU_URL,
  YONETICI_BANKA_LISTESI_URL, YONETICI_CARI_EKSTRE_LISTESI_URL, YONETICI_GELIR_IZLEME_LISTESI_URL,
  YONETICI_GELIR_TUR_LISTESI_URL,
  YONETICI_KASA_DURUMU_URL,
  YONETICI_MUKELLEF_BORC_LISTESI_URL,
  YONETICI_ODEME_IZLEME_LISTESI_URL,
  YONETICI_SICIL_LISTESI_URL,
  YONETICI_TAHSILAT_IZLEME_GRAFIK_VERISI_URL,
  YONETICI_TAHSILAT_IZLEME_LISTESI_URL,
  YONETICI_TAHSILAT_TUR_LISTESI_URL,
  YONETICI_TAHSILDAR_LISTESI_URL
} from "./constants";
import {BorcSorgulama} from "../yonetici/entities/BorcSorgulama";

class YoneticiService {

  getTahsilatIzlemeListesi(startDate: string, endDate: string) {
    const userInfo = window.sessionStorage.getItem("user");
    let user: User = JSON.parse(userInfo!);
    const token = encodeBase64(`${user?.username}:${user?.password}`);

    return axios.get(`${YONETICI_TAHSILAT_IZLEME_LISTESI_URL}/${startDate}/${endDate}`, {
      headers: {
        Authorization: `Basic ${token}`,
      },
    }).then((res) => res.data);
  }

  getTahsilatTurListesi() {
    const userInfo = window.sessionStorage.getItem("user");
    let user: User = JSON.parse(userInfo!);
    const token = encodeBase64(`${user?.username}:${user?.password}`);

    return axios.get(`${YONETICI_TAHSILAT_TUR_LISTESI_URL}`, {
      headers: {
        Authorization: `Basic ${token}`,
      },
    }).then((res) => res.data);
  }

  getTahsildarListesi() {
    const userInfo = window.sessionStorage.getItem("user");
    let user: User = JSON.parse(userInfo!);
    const token = encodeBase64(`${user?.username}:${user?.password}`);

    return axios.get(`${YONETICI_TAHSILDAR_LISTESI_URL}`, {
      headers: {
        Authorization: `Basic ${token}`,
      },
    }).then((res) => res.data);
  }

  getGelirTurListesi() {
    const userInfo = window.sessionStorage.getItem("user");
    let user: User = JSON.parse(userInfo!);
    const token = encodeBase64(`${user?.username}:${user?.password}`);

    return axios.get(`${YONETICI_GELIR_TUR_LISTESI_URL}`, {
      headers: {
        Authorization: `Basic ${token}`,
      },
    }).then((res) => res.data);
  }

  getTahsilatIzlemeGrafikVerisi(tarih: string) {
    const userInfo = window.sessionStorage.getItem("user");
    let user: User = JSON.parse(userInfo!);
    const token = encodeBase64(`${user?.username}:${user?.password}`);

    return axios.get(`${YONETICI_TAHSILAT_IZLEME_GRAFIK_VERISI_URL}/${tarih}`, {
      headers: {
        Authorization: `Basic ${token}`,
      },
    }).then((res) => res.data);
  }

  getKasaDurumu() {
    const userInfo = window.sessionStorage.getItem("user");
    let user: User = JSON.parse(userInfo!);
    const token = encodeBase64(`${user?.username}:${user?.password}`);

    return axios.get(`${YONETICI_KASA_DURUMU_URL}`, {
      headers: {
        Authorization: `Basic ${token}`,
      },
    }).then((res) => res.data);
  }

  getSicilListesi(adiSoyadiUnvan: string | undefined) {
    const userInfo = window.sessionStorage.getItem("user");
    let user: User = JSON.parse(userInfo!);
    const token = encodeBase64(`${user?.username}:${user?.password}`);

    return axios.post(`${YONETICI_SICIL_LISTESI_URL}`, {adiSoyadiUnvan}, {
      headers: {
        Authorization: `Basic ${token}`,
      },
    }).then((res) => res.data);
  }

  getMukellefBorcListesi(borcSorgulama: BorcSorgulama | undefined) {
    const userInfo = window.sessionStorage.getItem("user");
    let user: User = JSON.parse(userInfo!);
    const token = encodeBase64(`${user?.username}:${user?.password}`);

    return axios.post(`${YONETICI_MUKELLEF_BORC_LISTESI_URL}`, borcSorgulama, {
      headers: {
        Authorization: `Basic ${token}`,
      },
    }).then((res) => res.data);
  }
  getBankaListesi() {
    const userInfo = window.sessionStorage.getItem("user");
    let user: User = JSON.parse(userInfo!);
    const token = encodeBase64(`${user?.username}:${user?.password}`);

    return axios.get(`${YONETICI_BANKA_LISTESI_URL}`, {
      headers: {
        Authorization: `Basic ${token}`,
      },
    }).then((res) => res.data);
  }

  getBankaBakiyeDurumu(startDate: string, endDate: string) {
    const userInfo = window.sessionStorage.getItem("user");
    let user: User = JSON.parse(userInfo!);
    const token = encodeBase64(`${user?.username}:${user?.password}`);

    return axios.get(`${YONETICI_BANKA_BAKIYE_DURUMU_URL}/${startDate}/${endDate}`, {
      headers: {
        Authorization: `Basic ${token}`,
      },
    }).then((res) => res.data);
  }

  getOdemeIzlemeListesi(startDate: string, endDate: string) {
    const userInfo = window.sessionStorage.getItem("user");
    let user: User = JSON.parse(userInfo!);
    const token = encodeBase64(`${user?.username}:${user?.password}`);

    return axios.get(`${YONETICI_ODEME_IZLEME_LISTESI_URL}/${startDate}/${endDate}`, {
      headers: {
        Authorization: `Basic ${token}`,
      },
    }).then((res) => res.data);
  }

  getGelirIzlemeListesi(startDate: string, endDate: string) {
    const userInfo = window.sessionStorage.getItem("user");
    let user: User = JSON.parse(userInfo!);
    const token = encodeBase64(`${user?.username}:${user?.password}`);

    return axios.get(`${YONETICI_GELIR_IZLEME_LISTESI_URL}/${startDate}/${endDate}`, {
      headers: {
        Authorization: `Basic ${token}`,
      },
    }).then((res) => res.data);
  }

  getCariEkstreListesi() {
    const userInfo = window.sessionStorage.getItem("user");
    let user: User = JSON.parse(userInfo!);
    const token = encodeBase64(`${user?.username}:${user?.password}`);

    return axios.get(`${YONETICI_CARI_EKSTRE_LISTESI_URL}`, {
      headers: {
        Authorization: `Basic ${token}`,
      },
    }).then((res) => res.data);
  }
}

const yoneticiService = new YoneticiService();

export default yoneticiService;
